export default __webpack_public_path__ + "3afccee5544f5b9d2aa9ceb38758ca55.png";